import { useEffect, useRef, useState } from "react";
import { animate, motion, useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const Counter = ({ to, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val.toLocaleString()}
      {suffix}
    </span>
  );
};

const STATS = [
  { value: 1500, suffix: "+", label: "Projects delivered", note: "Dignifyd Tech", fill: 1 },
  { value: 98, suffix: "%", label: "Client satisfaction", note: "Rated 4.7 of 5", fill: 0.98 },
  { value: 35, suffix: "+", label: "Countries served", note: "Direct + partner network", fill: 0.7 },
  { value: 120, suffix: "+", label: "Group specialists", note: "Across five entities", fill: 0.55 },
  { value: 8, suffix: "+", label: "Years delivering", note: "Founded 2018", fill: 0.35 },
];

export default function StatsBand() {
  return (
    <section data-testid="stats-band" className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
      <div className="grid grid-cols-2 gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-3 lg:grid-cols-5">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className="bg-ink">
            <div className="flex h-full flex-col justify-between gap-6 p-6 lg:p-8">
              <p
                data-testid={`stat-value-${i}`}
                className="font-heading text-4xl font-bold tracking-tight text-white lg:text-5xl"
              >
                <Counter to={s.value} suffix={s.suffix} />
              </p>
              <div>
                <p className="text-sm font-medium text-gray-200">{s.label}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gray-500">
                  {s.note}
                </p>
                <div className="mt-4 h-px w-full bg-white/10">
                  <motion.div
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: s.fill }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                    className="h-px origin-left bg-gold"
                  />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
